module.exports = __webpack_public_path__ + "img/icon-star-light-white.c11971c1.svg";